import { adminApi } from './api';

/* ==========================================
  회원 관리 (User Management)
========================================== */

/**
 * 회원 목록 조회
 * @param {Object} params - { page, size, isStudent, groupId, searchType, keyword }
 * searchType은 검색 단위 (all, userId, name, email)
 * keyword 검색어
 * Note: page는 1부터 시작
 */
export const fetchUserList = async (params) => {
  const response = await adminApi.get(`/api/admin/users`, { params });
  return response.data.data;
};

/* 회원 상세 조회 */
export const fetchUserDetail = async (userId) => {
  const response = await adminApi.get(`/api/admin/users/${userId}`);
  return response.data.data;
};

/* ID 중복 검사 */
export const checkUserIdDuplicate = async (userId) => {
  // 백엔드 명세가 body에 { userId }를 받는 구조이므로 post 사용
  const response = await adminApi.post(`/api/admin/users/check/id`, { userId });
  return response.data.data;
};

/* 회원 등록 (단건) */
export const joinUser = async (userData) => {
  // userData: { userId, name, email, password, role, expiredAt, groupId }
  const response = await adminApi.post(`/api/admin/users/join`, userData);
  return response.data.data;
};

/**
 * 회원 대량 등록 (Excel)
 * @param {File} file - 업로드할 엑셀 파일 객체
 */
export const joinUsersBulk = async (groupId, file, sendWelcomeEmail) => {
  const formData = new FormData();
  formData.append('userFile', file);
  formData.append('sendWelcomeEmail', sendWelcomeEmail);
  const response = await adminApi.post(`/api/admin/users/groups/${groupId}/bulk`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

/* 회원 정보 수정 */
export const updateUser = async (userData) => {
  // userData: { userId, name, email, groupId }
  const response = await adminApi.put(`/api/admin/users`, userData);
  return response.data.data;
};

/* 회원 상태 변경 */
export const updateUserStatus = async (userId, status, secessionOpinion) => {
  // status: 'active' | 'inactive' | 'secession'
  const payload = { userId, status };
  if (status === 'secession') {
    payload.secessionOpinion = secessionOpinion;
  }
  const response = await adminApi.patch(`/api/admin/users/status`, payload);
  return response.data.data;
};

/* 회원 삭제 */
export const deleteUser = async (userId) => {
  const response = await adminApi.delete(`/api/admin/users/${userId}`);
  return response.data.data;
};